/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

// recommendationTabUtils.ts

export const RECOMMENDATION_TAB_TITLE_BY_ID: Record<string, string> = {
  for_you: 'For you',
  promotions: 'Promotions',
  movements: 'Movements',
};

export const getRecommendationTabEnglishTitleFromId = (
  tabId: string,
): string => {
  return RECOMMENDATION_TAB_TITLE_BY_ID[tabId] || tabId;
};

/** Display title for tabs: keep locale strings, but force English "For You" → "For you". */
export const getRecommendationTabDisplayTitle = (tab: {
  id: string;
  title: string;
}): string => {
  const tabId = String(tab.id).toLowerCase();
  if (tabId === 'for_you' && tab.title.trim().toLowerCase() === 'for you') {
    return RECOMMENDATION_TAB_TITLE_BY_ID.for_you;
  }
  return tab.title;
};
